<template>
  <div class="group__info margin-top-10 padding-bottom-10"
       v-if="vbOpinionForms && vbOpinionForms.length"
  >
    <div class="title font-size__medium">{{ title }}</div>
    <div class="content">
      <div class="form-input">
        <template>
          <el-table
            class="table detailRelatedDocs"
            style="width: 100%;"
            :data="vbOpinionForms"
            size=""
          >
            <el-table-column label="Nội dung" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="docName flex-row flex__left margin-right-10">
                  <file-type-image
                    :custom-class="''"
                    :file-extention="scope.row.fileExtention"
                  >
                  </file-type-image>
                  <a
                    class="txt style-fullWidth margin-left-10 color__black clickable"
                    @click="downloadFile(scope.row)"
                  >
                    {{ scope.row.content || "-" }}
                  </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Người cho ý kiến"
              width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  class="style-fullWidth inputBg__white"
                  size="mini"
                  v-model="scope.row.fullName"
                  :disabled="true"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FileTypeImage from "../job/FileTypeImage";
import constants from "../../constants";
import h from "../../services/h";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import DialogAddDocs from "../job/create-job/dialog-add-docs";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import downloadService from "../../services/downloadService";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import vbOpinionFormService from "../../services/vbOpinionFormService";
import utils from "../../services/utils";

export default {
  name: "doc-relations-form",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: { DialogAddDocs, FileTypeImage },
  props: ["title", "docId", "categoryCode"],

  data() {
    return {
      attachedType: constants.DOC_RELATION_ATTACHED_TYPE.PHIEU_Y_KIEN,
      vbOpinionForms: [],
      isUploadingRelationDocFlag: null,
      uploadRelationDocAdditionalData: {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.RELATION_DOC
      },
      docIds: [],
      listUserPYK: [],
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION
    };
  },

  watch: {
    docId() {
      this.loadListUserPYK();
    },
    categoryCode(){
      this.loadListUserPYK();
    }
  },

  created() {
    this.loadListUserPYK();
  },

  methods: {
    loadListUserPYK() {
      console.log('loadListUserPYK', this.categoryCode);
      if(this.categoryCode){
        let deptCode = constants.HDTV_DEPT_CODE;
        if (this.categoryCode &&
          (this.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BTVDU
            || this.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BTVDU)
        ) {
          deptCode = constants.TVDU_DEPT_CODE;
        } else if (this.categoryCode &&
          (this.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BKTDU
            || this.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BKTDU)
        ) {
          deptCode = constants.UBKT_DEPT_CODE;
        } else if (this.categoryCode &&
          (this.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_HDTDKT
            || this.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_HDTDKT)
        ) {
          deptCode = constants.HDTDKT_DEPT_CODE;
        }
        return userDeptRoleViewService
          .findAll({
            deptCode: deptCode,
            roleCode: constants.ROLE.CODE.LANH_DAO
          })
          .then(res => {
            this.listUserPYK = res.data;
            if (this.listUserPYK)
              this.listUserPYK.sort((a, b) => utils.compareUserDeptRoleView(a, b));
            this.loadVbOpinionForms();
          });
      }
    },

    loadVbOpinionForms() {
      console.log('loadVbOpinionForms', this.docId);
      console.log('listUserPYK', this.listUserPYK);
      this.vbOpinionForms = [];
      if (!this.docId) return;
      return vbOpinionFormService
        .findByDocId(this.docId)
        .then(response => {
          console.log('loadVbOpinionForms', response);
          h.each(response.data, item => {
            this.vbOpinionForms.push({
              docId: item.docId,
              userDeptRoleId: item.userDeptRoleId,
              roleId: item.roleId,
              userId: item.userId,
              deptId: item.deptId,
              fullName: this.listUserPYK.find(userPYK => userPYK.id === item.userDeptRoleId).fullName,
              attachDocumentId: item.attachDocumentId,
              content: item.content
            });
          });
        });
    },

    getVbOpinionForms() {
      return this.vbOpinionForms;
    },

    downloadFile(vbOpinionForm) {
      downloadService.downloadFileCommon(
        vbAttachmentTokenService
          .getToken(vbOpinionForm.attachDocumentId)
          .then(response => response.data),
        constants.DOWNLOAD_FILE_URL.DEFAULT_URL
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/phieu-ykien-detail.vue